export const environment = {
  // Staging HTTPS
  // apiBaseURL: "https://stg-beapi-games-rgs.negroup-tech.net/vleague/api/",
  // wsEndPoint: "https://stg-beapi-games-rgs.negroup-tech.net",
  // staging
  // apiBaseURL: "http://stg-beapi-games-rgs.negroup-tech.net:7073/api/",
  // wsEndPoint: "http://stg-beapi-games-rgs.negroup-tech.net:7073",
  // DEV HTTPS(QA)
  // apiBaseURL: "https://dev-beapi-games-rgs.negroup-tech.net/vleague/api/",
  // wsEndPoint: "https://dev-beapi-games-rgs.negroup-tech.net",
  // DEV
  // apiBaseURL: "http://dev-beapi-games-rgs.negroup-tech.net:7073/api/",
  // wsEndPoint: "http://dev-beapi-games-rgs.negroup-tech.net:7073",
  // LOCAL(.env)
  // apiBaseURL: "http://localhost:7073/api/",
  // wsEndPoint: "http://localhost:7073",
  // INTERNAL QA(env DEV)
  // apiBaseURL: "http://10.10.1.13:7073/api/",
  // wsEndPoint: "http://10.10.1.13:7073",
  defaultSessionParams: {
    playerId: "_99",
    platformId: "0",
    operatorId: "demo",
    gameId: "vleague",
    brand: "demo",
    currency: "INR",
    region: "IN",
    language: "en",
    playerName: "",
  },
};
